export default "__VITE_ASSET__LA_Hm2Jh__"